// DocQuery.js

import process from "process";
const API_BASE_URL =process.env.REACT_APP_API_URL; 

/**
 * Met à jour les données pour une instance spécifique.
 * @param {string} token Le token d'authentification
 * @param {string} instanceId L'ID de l'instance à mettre à jour
 * @param {Object} updateData Les données à mettre à jour
 * @returns {Promise<Object>} Le résultat de l'appel d'API
 */
export async function docUpdate(token,InstanceId, DocumentId, sComplexite, prio, isValid,status) {

  const url = `${API_BASE_URL}/document/update`;
  try {
    const response = await fetch(url, {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
      body: JSON.stringify(
        {
            "DocumentId" : DocumentId,
            "InstanceId" : InstanceId,            
            "FieldList" : {
                "sComplexite" : sComplexite,
                "bValid" : isValid,
                "dPriorite" : prio,
                "sStatus":status
            
        }
    }),
    });

    if (!response.ok) {
      alert('Mise à jour échoué pour le doc' + DocumentId )
      throw new Error(`Erreur API: ${response.status} ${response.statusText}`);
    }

    return await response.json(); 
  } catch (error) {
    console.error("Erreur lors de la mise à jour de l'instance:", error);
    throw error; 
  }
}
